import { SvgIcon } from "@mui/material";

export default function PdfDocDefault(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3048 4.11627C14.3048 3.77929 14.0313 3.50581 13.6943 3.50581H2.29894C1.96197 3.50581 1.68848 3.77929 1.68848 4.11627V15.1047C1.68848 15.8063 1.96685 16.4794 2.46336 16.9751C2.95906 17.4716 3.6322 17.75 4.33383 17.75H11.6594C12.3611 17.75 13.0342 17.4716 13.5299 16.9751C14.0264 16.4794 14.3048 15.8063 14.3048 15.1047C14.3048 11.4419 14.3048 4.11627 14.3048 4.11627ZM13.0838 4.72674V15.1047C13.0838 15.4823 12.9341 15.8445 12.6663 16.1115C12.3993 16.3793 12.0371 16.5291 11.6594 16.5291C9.59035 16.5291 6.4029 16.5291 4.33383 16.5291C3.95616 16.5291 3.59395 16.3793 3.32697 16.1115C3.05918 15.8445 2.90941 15.4823 2.90941 15.1047V4.72674H13.0838Z"
          fill="#8E97A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6602 4.72675C11.9972 4.72675 12.2706 4.45326 12.2706 4.11629C12.2706 4.11629 12.2706 3.30233 12.2706 2.48838C12.2706 1.895 12.0346 1.32523 11.6154 0.905234C11.1954 0.486047 10.6256 0.25 10.0323 0.25C8.82111 0.25 7.17366 0.25 5.9625 0.25C5.36912 0.25 4.79936 0.486047 4.37935 0.905234C3.96017 1.32523 3.72412 1.895 3.72412 2.48838V4.11629C3.72412 4.45326 3.99761 4.72675 4.33459 4.72675H11.6602ZM11.0497 3.50582H4.94505V2.48838C4.94505 2.21814 5.0525 1.96012 5.24296 1.76884C5.43424 1.57837 5.69226 1.47093 5.9625 1.47093H10.0323C10.3025 1.47093 10.5605 1.57837 10.7518 1.76884C10.9423 1.96012 11.0497 2.21814 11.0497 2.48838V3.50582Z"
          fill="#8E97A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5085 3.50579H1.48522C1.14824 3.50579 0.874756 3.77928 0.874756 4.11626C0.874756 4.45323 1.14824 4.72672 1.48522 4.72672H14.5085C14.8455 4.72672 15.119 4.45323 15.119 4.11626C15.119 3.77928 14.8455 3.50579 14.5085 3.50579Z"
          fill="#8E97A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.35132 7.77907V13.4768C5.35132 13.8137 5.62481 14.0872 5.96178 14.0872C6.29876 14.0872 6.57225 13.8137 6.57225 13.4768V7.77907C6.57225 7.44209 6.29876 7.1686 5.96178 7.1686C5.62481 7.1686 5.35132 7.44209 5.35132 7.77907Z"
          fill="#8E97A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.42114 7.77907V13.4768C9.42114 13.8137 9.69463 14.0872 10.0316 14.0872C10.3686 14.0872 10.6421 13.8137 10.6421 13.4768V7.77907C10.6421 7.44209 10.3686 7.1686 10.0316 7.1686C9.69463 7.1686 9.42114 7.44209 9.42114 7.77907Z"
          fill="#8E97A7"
        />
      </svg>
    </SvgIcon>
  );
}
